import { ScrollArea } from '@/components/shadcn/scroll-area'
import { Checkbox } from '@/components/shadcn/checkbox'
import { Label } from '@/components/shadcn/label'

export interface CheckListItem {
  id: number | string | null
  label: string
  icon?: React.ReactNode
}

interface Props {
  items: CheckListItem[]
  selected: (number | string)[]
  onChange: (ids: (number | string)[]) => void
  emptyText?: string
  className?: string
}

export function CheckList({ items, selected, onChange, emptyText, className }: Props) {
  const toggle = (id: number | string) => {
    onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id])
  }

  return (
    <ScrollArea className={className ?? 'h-36 rounded-md border p-2'}>
      <div className="flex flex-col gap-2">
        {items.length === 0 && (
          <p className="text-xs text-muted-foreground px-1">{emptyText ?? 'Keine Einträge vorhanden.'}</p>
        )}
        {items.map((item) => (
          <div key={String(item.id)} className="flex items-center gap-2">
            <Checkbox
              id={`item-${item.id}`}
              checked={item.id != null && selected.includes(item.id)}
              onCheckedChange={() => item.id != null && toggle(item.id)}
            />
            <Label htmlFor={`item-${item.id}`} className="flex cursor-pointer items-center gap-1.5 font-normal text-sm">
              {item.icon}
              {item.label}
            </Label>
          </div>
        ))}
      </div>
    </ScrollArea>
  )
}
